export const filtrarCuotasPorYear = (cuotas, year) => !year ? cuotas : cuotas.filter(cuota =>
  new Date(cuota.fecha).getUTCFullYear() === Number(year)
)

export const getMesesCredito = (row, year) => {
  const cuotas = row.extras?.cuotas ?? []
  return [...new Set(filtrarCuotasPorYear(cuotas, year)
    .map(cuota => new Date(cuota.fecha).getUTCMonth() + 1))]
}
